import { Component, OnInit } from '@angular/core';
import { ScreenSize } from 'libs/portal/src/layout/layout.service';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { TitleService } from 'libs/portal/src/services/title/title.service';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { LoginRequest, UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { CardTableAction, CardTableOptions } from 'libs/portal/src/modules/tools/card-table/models';
import { CardTableHeader } from 'libs/portal/src/modules/tools/card-table/models/card-table-header.model';
import { Endpoints } from '@huge-monorepo/portal/config';
import { Routes } from '@huge-monorepo/portal/config';
import { GenericTableHeaderOptions, RefreshData } from 'libs/portal/src/modules/tools/card-table/models/generic-table-header-options.model';
import { Location } from '@angular/common';

@Component({
  selector: 'app-change-session',
  templateUrl: './change-session.component.html',
  styleUrls: ['./change-session.component.scss'],
})
export class ChangeSessionComponent implements OnInit {
  groups: any[];
  totalGroups;
  currentGroup;
  currentDefaultGroup;

  currentGroupPage = 1;
  groupOrderBy = 'Name';
  groupSearch = '';
  groupSortDesc = false;
  groupTableCount = 10;
  groupTableOffset = 0;
  loading = false;

  ScreenSize = ScreenSize;

  groupTableOptions: CardTableOptions = {
    titleProperty: 'Name',
    subTitleProperty: 'NumServers',
    textSize: 'regular',
    rowId: 'ID',
    contentProperty: 'Name',
    selectedProperty: 'selected',
    isSelectable: false,
    flexCardLayout: false,
    propertyRowExclusions: [
      'AlertSettings',
      'AuthReference',
      'CDRAccess',
      'CreatedOn',
      'DataAccesses',
      'HasSharedServerAccess',
      'ID',
      'KeepAliveAccess',
      'KeepAliveServers',
      'MikrotikAccess',
      'RelayAccess',
      'ContractorsAccess',
      'TeltonikaAccess',
      'MaxUsers',
      'User',
      'UserID',
      'Users',
      'Revoked',
      'NumServers',
      'PortalUsers',
      'UsageLimitsConfig'
    ],
    clickableFlexCard: false,
  };

  headerOptions: GenericTableHeaderOptions = {
    ShowSearch: true,
    SearchPlaceholder: 'Search Groups',
    DefaultDesc: false,
    DefaultSort: 'Name',
    SortItems: [
      {
        Name: 'Name',
        Display: 'Name',
      },
    ],
  };

  headers: CardTableHeader[] = [
    {
      ID: 'Name',
      Text: 'Name',
      Width: 65,
    },
  ];

  notDefaultNotActive: CardTableAction[] = [
    {
      title: 'Set as Default',
      iconSrc: 'assets/icon/change-session.svg',
      color: 'primary',
      showIcon: false,
    },
    {
      title: 'Change Session',
      iconSrc: 'assets/icon/change-session.svg',
      color: 'primary',
      showIcon: true,
    },
  ];

  notDefaultActive: CardTableAction[] = [
    {
      title: 'Set as Default',
      iconSrc: 'assets/icon/change-session.svg',
      color: 'primary',
      showIcon: false,
    },
    {
      title: '(Current Group)',
      iconSrc: 'assets/icon/change-session.svg',
      color: 'primary',
      showIcon: false,
    },
  ];

  defaultActive: CardTableAction[] = [
    {
      title: '(Default Group)',
      iconSrc: 'assets/icon/change-session.svg',
      color: 'primary',
      showIcon: false,
    },
    {
      title: '(Current Group)',
      iconSrc: 'assets/icon/change-session.svg',
      color: 'primary',
      showIcon: false,
    },
  ];

  defaultNotActive: CardTableAction[] = [
    {
      title: '(Default Group)',
      iconSrc: 'assets/icon/change-session.svg',
      color: 'primary',
      showIcon: false,
    },
    {
      title: 'Change Session',
      iconSrc: 'assets/icon/change-session.svg',
      color: 'primary',
      showIcon: true,
    },
  ];

  isSuperUser = false;
  constructor(
    private titleService: TitleService,
    private genericService: GenericService,
    private endpoints: Endpoints,
    private tools: ToolsService,
    private auth: UserRightsService,
    private routes: Routes,
    private location: Location,
  ) { }

  ngOnInit() {
    this.titleService.pageTitle = 'Change Session';
    // this.closePopover();
    this.currentGroup = this.auth.GetGroupID();
    this.currentDefaultGroup = this.auth.GetDefualtGroupID();
    this.getUserGroups(this.groupOrderBy, this.groupSearch, this.groupTableCount, this.groupTableOffset, this.groupSortDesc);
    this.isSuperUser = this.auth.GetUserAccessRoles().IsSuperUser();
  }

  getUserGroups(orderBy: string, search: string, count: number, offset: number, desc: boolean) {
    this.loading = true;
    this.groups = null;
    this.genericService.GET(this.endpoints.GET_USER_GROUPS(count, offset, search, orderBy, desc)).subscribe((res) => {
      if (res['body'] != null) {
        this.groups = res['body'];
        this.totalGroups = this.tools.ExtractPaginationFromHeaders(res['headers']);
      }
      this.loading = false;
    });
  }

  refreshTable(data: RefreshData): void {
    this.groupSearch = data.Search ?? '';
    this.groupOrderBy = data.Sort ?? '';
    this.groupSortDesc = data.Desc ?? this.groupSortDesc;
    this.groupTableOffset = 0;
    this.currentGroupPage = 1;
    this.getUserGroups(this.groupOrderBy, this.groupSearch, this.groupTableCount, this.groupTableOffset, this.groupSortDesc);
  }

  onGroupAction(ev) {
    if (ev.title == 'Change Session') {
      this.loading = true;
      const userId = this.auth.GetUID();

      const switchObj = {
        UserID: userId,
        GroupID: ev.row.ID,
      };

      this.genericService.POST(this.endpoints.CHANGE_SESSION, switchObj).subscribe((res) => {
        if (res['body'] != null) {
          const response = res['body'];
          this.auth.ClearAccesses();
          // TODO: Change the Impersonated keys when integrating
          const loginRequest = new LoginRequest(
            response['user']['ID'],
            0,
            response['user']['UserID'],
            response['user']['Email'],
            response['user']['Name'],
            response['token'],
            response['user']['GroupID'],
            response['user']['GroupName'],
            response['user']['KeepAliveAccess'],
            response['user']['CDRAccess'],
            response['user']['MikrotikAccess'],
            response['user']['RelayAccess'],
            response['user']['UserAccessRoles'],
            response['user']['ImpersonatedUserAccessRoles'],
            response['user']['ImpersonatedUser'],
            response['user']['HugeAdmin'],
            response['user']['KeepAliveTypes'],
            response['user']['PortalReadAccess'],
            response['user']['PortalWriteAccess'],
            null,
            null,
            null,
            null,
            response['user']['TeltonikaAccess'],
            response['user']['ContractorsAccess'],
          );
          loginRequest.DefaultGroupID = response['user']['DefaultGroupID'];
          loginRequest.IsAggregated = response['user']['IsAggregated'];

          this.auth.Login(loginRequest);
          this.auth.SetSessionChanged(true);
          setTimeout(() => {
            this.loading = false;
            window.location.replace(this.routes.Home);
          });
        }
      });
    } else if (ev.title == 'Set as Default') {
      this.loading = true;

      const sendObj = {
        GroupId: ev.row.ID,
      };

      this.genericService.PUT(this.endpoints.UPDATE_USER_DEFAULT_GROUP(this.auth.GetUID()), sendObj).subscribe(() => {
        this.auth.SetDefaultGroupID(ev.row.ID);
        this.currentDefaultGroup = this.auth.GetDefualtGroupID();
        this.getUserGroups(this.groupOrderBy, this.groupSearch, this.groupTableCount, this.groupTableOffset, this.groupSortDesc);
      });
    }
  }

  getPagedGroups(ev: number) {
    this.currentGroupPage = ev;
    this.groupTableOffset = (this.currentGroupPage - 1) * this.groupTableCount;
    this.getUserGroups(this.groupOrderBy, this.groupSearch, this.groupTableCount, this.groupTableOffset, this.groupSortDesc);
  }

  goBack(): void {
    this.location.back();
  }
}
